import { currency } from '@/utils';
export default class WorkerWithholdTax {
    _incomeTaxAmount;
    _incomeTaxAmountWithLocalIncomeTax;
    _totalAmount;
    _withholdTaxAmount;
    _workerCount;
    constructor({ incomeTaxAmount, incomeTaxAmountWithLocalIncomeTax, totalAmount, withholdTaxAmount, workerCount, }) {
        this._incomeTaxAmount = incomeTaxAmount;
        this._incomeTaxAmountWithLocalIncomeTax = incomeTaxAmountWithLocalIncomeTax;
        this._totalAmount = totalAmount;
        this._withholdTaxAmount = withholdTaxAmount;
        this._workerCount = workerCount;
    }
    // 인원수
    get workerCount() {
        return this._workerCount;
    }
    // 총지급금액
    get totalAmount() {
        return currency(this._totalAmount);
    }
    // 소득세
    get incomeTaxAmount() {
        return currency(this._incomeTaxAmount);
    }
    // 지방소득세 포함시 소득세
    get incomeTaxAmountWithLocalIncomeTax() {
        return currency(this._incomeTaxAmountWithLocalIncomeTax);
    }
    // 실 원천징수액
    get withholdTaxAmount() {
        return currency(this._withholdTaxAmount);
    }
}
